"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.routing = void 0;
var envIsLocal = process.env.REACT_APP_ENV === 'local'; // when local, we want port to be 3001 (because the apps run on :3000), other environments we keep
// the same port that the app is running on (because cloudfront will route the request to cerberus)

var usePort = envIsLocal ? '3001' : location.port;
var basePath = "".concat(location.protocol, "//").concat(location.hostname).concat(usePort ? ":".concat(usePort) : '', "/login");
var routing = {
  login: function login() {
    return "".concat(basePath, "/login");
  },
  logout: function logout() {
    return "".concat(basePath, "/logout");
  },
  callback: function callback() {
    return "".concat(basePath, "/callback");
  },
  silentCallback: function silentCallback() {
    return "".concat(basePath, "/silent-callback");
  },
  selectTenant: function selectTenant() {
    return "".concat(basePath, "/select-tenant");
  }
};
exports.routing = routing;
var _default = routing;
exports.default = _default;